import { render, staticRenderFns } from "./ListPlans.vue?vue&type=template&id=0e2b4dc6"
import script from "./ListPlans.vue?vue&type=script&lang=js"
export * from "./ListPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports